import { render } from "./contactPage.vue?vue&type=template&id=07d08480&scoped=true"
import script from "./contactPage.vue?vue&type=script&lang=js"
export * from "./contactPage.vue?vue&type=script&lang=js"

import "./contactPage.vue?vue&type=style&index=0&id=07d08480&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07d08480"]])

export default __exports__